// extracted by mini-css-extract-plugin
export default {"placeholder":"index_placeholder_h5DTn","wrap":"index_wrap_F5-iL","list":"index_list_V6atL"};